// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum DesigoOpticSiteServerType {
  SmallSiteServer = 0,
  MediumSiteServer = 1,
  LargeSiteServer = 2,
}
